import { compose, join, map, prop } from "ramda";
export default compose(join(", "), map(prop("name")));
